<!-- Desktop HTML -->
<div *ngIf='screenWidth >= 1230'>
  <div (window:orientationchange)="screenRotate($event)">
    <div class="flex-container">
      <div class="bmw-lg-sib-sidebar flex-12-5">
        <div style="font-weight:bold">Filter by</div>
        <div style="margin-top:15px">Main Group</div>
        <div>
          <select class="form-control" id="group" [(ngModel)]='inputMainGroup'>
            <option [ngValue]="undefined" disabled selected> Select Main Group </option>
            <option *ngFor="let group of mainGroupList" [ngValue]="group">{{ group }}</option>
          </select>
        </div>

        <div style="margin-top:25px">Series</div>
        <div>
          <!-- <input type="input" (focusout)='updateBodyValues()' placeholder="Enter Series" [(ngModel)]='inputSeries'> -->

          <select class="form-control" id="series" [(ngModel)]='inputSeries'>
            <option [ngValue]="undefined" disabled selected>Select Series</option>
            <option *ngFor="let series of inputSeriesGroup" [ngValue]="series">{{ series }}</option>
          </select>

        </div>

        <div style="margin-top:25px">Year Published</div>
        <div class="flex-container row">
          <div class="flex-28" style="padding-top:10px">From</div>
          <div class="flex" style="width:100%">
            <select class="form-control" id="fromYear" [(ngModel)]='inputFromYear'>
              <option *ngFor="let year of fromYears" [ngValue]="year">{{year}}</option>
            </select>
          </div>
        </div>
        <div class="flex-container row">
          <div class="flex-28" style="padding-top:10px">To</div>
          <div class="flex" style="width:100%">
            <select class="form-control" id="toYear" [(ngModel)]='inputToYear'>
              <option *ngFor="let year of toYears" [ngValue]="year">{{year}}</option>
            </select>
          </div>
        </div>
        <!-- <button [disabled]='noContent' [ngStyle]='{"background-color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22":"#1c69d4"}' class="pointer bmw-button-primary lg-primary"
          (click)='applyFilter()'>Apply Filter</button> -->
          <!-- RR changes -->
          <button [disabled]='noContent' [ngStyle]='{"background-color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}' class="pointer bmw-button-primary lg-primary"
          (click)='applyFilter()'>Apply Filter</button>
        <div class="pointer bmw-button-secondary lg-secondary" (click)='clearFilter()'>Cancel Filter</div>
        <a [routerLink]='["/manage-profile", "bulletin-manager"]'>
          <div class="bmw-lg-sib-bulletin-manager-label" [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>Saved Bulletin Manager</div>
        </a>
      </div>
      <div class="flex">
        <div class="flex-container row">
          <div class="flex-8"></div>
          <div class="flex-81-3">
            <div>
              <div class="flex-30"></div>
              <div class="flex-container row flex-align-center">
                  <div [ngClass]='{"bmw-active-link": isShowAll && (APP_SETTINGS.isBMW === "true" || APP_SETTINGS.isMOTORRAD === "true"),
                   "mini-active-link": isShowAll && APP_SETTINGS.isMINI === "true",
                  "rr-active-link": isShowAll && APP_SETTINGS.isRollsRoyce === "true"}'
                  class="pointer" style="padding-bottom: 20px" (click)='showAll()'>ALL</div>
                  
                <div [ngClass]='{"bmw-active-link": isShowNew && (APP_SETTINGS.isBMW === "true" || APP_SETTINGS.isMOTORRAD === "true"),
                 "mini-active-link": isShowNew && APP_SETTINGS.isMINI === "true",
                 "rr-active-link": isShowNew && APP_SETTINGS.isRollsRoyce === "true"}'
                  class="pointer" style="padding-bottom: 20px" (click)='showNew()'>
                  NEW
                  <div class="badge" *ngIf="newDocsCount>0" [ngStyle]='{"background-color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" :"#1c69d4"}'>{{newDocsCount}}</div>
                </div>
                <div [ngClass]='{"bmw-active-link": isShowHistory && (APP_SETTINGS.isBMW === "true" || APP_SETTINGS.isMOTORRAD === "true")
                , "mini-active-link": isShowHistory && APP_SETTINGS.isMINI === "true",
                "rr-active-link": isShowHistory && APP_SETTINGS.isRollsRoyce === "true"}'
                  class="pointer" style="padding-bottom: 20px" (click)='showHistory()'>HISTORY</div>
                <div [ngClass]='{"bmw-active-link": isShowSaved && (APP_SETTINGS.isBMW === "true" || APP_SETTINGS.isMOTORRAD === "true"),
                 "mini-active-link": isShowSaved && APP_SETTINGS.isMINI === "true",
                 "rr-active-link": isShowSaved && APP_SETTINGS.isRollsRoyce === "true"}'
                  class="pointer" style="padding-bottom: 20px" (click)='showSaved()'>SAVED</div>
              </div>
              <div class="flex-30"></div>
            </div>
            <div class="bmw-lg-sib-content" #scrollingBlock>
              <div class="flex-container row" style="padding:27px 20px 34px 30px">
                <div class="bmw-lg-sib-title flex">Service Bulletins</div>
                <div class="flex"></div>
                <div class="flex-32">
                  <form class="input-group" name="findDocs" style="width: 100%">
                    <input type="text" class="form-control" size=15 style="height:34px;font-size:16px;border-radius:0px" placeholder="Find Bulletin"
                      name="techDoc" [(ngModel)]="search4bulletins">
                    <div class="input-group-btn">
                      <button [ngClass]="{'mini-button-style' : APP_SETTINGS.isMINI === 'true', 'bmw-button-style': (APP_SETTINGS.isBMW === 'true' || APP_SETTINGS.isMOTORRAD === 'true'),
                    'rr-button-style' : APP_SETTINGS.isRollsRoyce === 'true'}" class="btn btn-default"
                        type="submit" (click)='disablePagination()'>
                        <i class="glyphicon glyphicon-search"></i>
                      </button>
                    </div>
                  </form>
                </div>
              </div>
              <div *ngIf='isShowSaved'>
                <div class="alert alert-warning" role="alert" *ngIf='errorMessage?.length > 0'>{{errorMessage}}</div>
                <div *ngIf='serviceBulletins?.length > 0'>
                  <div *ngFor='let doc of serviceBulletins; let i=index'>
                    <div class="flex-container row" style="margin:0 30px" >
                      <div class="flex-5">
                        <i class="material-icons"> </i>
                      </div>
                      <div class="flex-20" style="font-weight: bold;line-height:1.8">
                        Bulletin number
                      </div>
                      <div class="flex-70" style="font-weight: bold;line-height:1.8">
                        Bulletin Description
                      </div>
                      <div  style="font-weight: bold;line-height:1.8">
                        Release
                      </div>
                    </div>
                    <div [id]='"pbs" + i' class="bmw-lg-save">
                      <div [routerLink]="['/bulletin', bulletin?.bulletinDisplayId]" [queryParams]='{type: "sib",page:page}' *ngFor='let bulletin of doc?.content' style="margin-left:4%" class="fa pointer flex-container row" >
                        <div class="flex-5" style="text-align:center">
                          <div *ngIf='bulletin?.savedBulletinGroup; else elseBlock'>
                            <i class="material-icons">star</i>
                          </div>
                          <ng-template #elseBlock>
                            <ng-container *ngIf='bulletin?.updatedBulletin; else elseBlock2'>
                              <i class="material-icons">new_releases</i>
                            </ng-container>
                          </ng-template>
                          <ng-template #elseBlock2>
                            <ng-container *ngIf='bulletin?.newBulletin'>
                              <i class="material-icons">fiber_new</i>
                            </ng-container>
                          </ng-template>
                        </div>
                        <div class="flex-12">{{bulletin?.bulletinDisplayNumber}}</div>
                        <div class="flex-70">{{bulletin.description}}</div>
                        <div class="flex">{{bulletin.releaseDate | date: 'yyyy-MM-dd'}}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div *ngIf='!isShowSaved'>
                <div class="flex-container row" style="border-bottom:2px solid #e9e9e9;">
                  <div class="flex-5"></div>
                  <div style="display:inherit" class="flex-8">
                    <div style="font-weight:bold;font-size:12px;">Bulletin#</div>
                    <i class="fa pointer" (click)="sortByProperty('bulletinIdForSort')" style="margin-left:5px" [ngClass]="{'fa-sort': column != 'bulletinIdForSort', 'fa-sort-asc bmw-sort-control-asc': (column == 'bulletinIdForSort' && isDesc), 'fa-sort-desc': (column == 'bulletinIdForSort' && !isDesc) }"
                      aria-hidden="true"> </i>
                  </div>
                  <div class="flex-4"></div>
                  <div style="display:inherit" class="flex-40">
                    <div style="font-weight:bold;font-size:12px;">Title</div>
                    <i class="fa pointer" (click)="sortByProperty('description')" style="margin-left:5px" [ngClass]="{'fa-sort': column != 'description', 'fa-sort-asc bmw-sort-control-asc': (column == 'description' && isDesc), 'fa-sort-desc': (column == 'description' && !isDesc) }"
                      aria-hidden="true"> </i>
                  </div>
                  <div class="flex-7"></div>
                  <div style="display:inherit" class="flex-17">
                    <div style="font-weight:bold;font-size:12px;">Series</div>
                    <i class="fa pointer" (click)="sortByProperty('series')" style="margin-left:5px" [ngClass]="{'fa-sort': column != 'series', 'fa-sort-asc bmw-sort-control-asc': (column == 'series' && isDesc), 'fa-sort-desc': (column == 'series' && !isDesc) }"
                      aria-hidden="true"> </i>
                  </div>
                  <div class="flex-7"></div>
                  <div style="display:inherit" class="flex">
                    <div style="font-weight:bold;font-size:12px;">Date</div>
                    <i class="fa pointer" (click)="sortByProperty('releaseDate')" style="margin-left:5px" [ngClass]="{'fa-sort': column != 'releaseDate', 'fa-sort-asc bmw-sort-control-asc': (column == 'releaseDate' && isDesc), 'fa-sort-desc': (column == 'releaseDate' && !isDesc) }"
                      aria-hidden="true"> </i>
                  </div>
                </div>
                <div class="alert alert-warning" role="alert" *ngIf='errorMessage?.length > 0'>{{errorMessage}}</div>
                
                <ng-template [ngIf]="!isPaginateFlag" [ngIfElse]="disablePaginationSec">
                  <a [routerLink]="['/bulletin', doc.bulletinDisplayId]" [queryParams]='{type: "sib",page:page}' *ngFor='let doc of serviceBulletins | filterResults : filter |
                    searchFilter: "bulletinDisplayNumber,bulletinDisplayId,releaseDate,description,seriesAsString": search4bulletins | sortBy: {property: column, direction: direction} | paginate: { itemsPerPage: 20, currentPage: page }'
                    class="bmw-lg-sib pointer flex-container row" (click)='addBulletinToHistory(isShowHistory, doc?.id)'>

                    <div class="flex-5" style="text-align:center">
                      <div *ngIf='doc?.savedBulletinGroup; else elseBlock'>
                        <i class="material-icons">star</i>
                      </div>
                      <ng-template #elseBlock>
                        <ng-container *ngIf='doc?.updatedBulletin; else elseBlock2'>
                          <i class="material-icons">new_releases</i>
                        </ng-container>
                      </ng-template>
                      <ng-template #elseBlock2>
                        <ng-container *ngIf='doc?.newBulletin'>
                          <i class="material-icons">fiber_new</i>
                        </ng-container>
                      </ng-template>
                    </div>
                    <div class="flex-8">{{doc?.bulletinDisplayNumber}}</div>
                    <div class="flex-4"></div>
                    <div class="flex-40">{{doc?.description}}</div>
                    <div class="flex-7"></div>
                    <div class="flex-17">
                      <div *ngFor='let series of doc?.series | loadMoreItems : numOfItems' style="float: left; margin-right:18px">
                        {{series?.seriesName}}
                      </div>
                      <div class="pointer" (click)='numOfItems = numOfItems + 6' *ngIf='((doc?.series | loadMoreItems : numOfItems)?.length < doc?.series?.length)'
                        style='float:left' [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>+6</div>
                    </div>
                    <div class="flex-7"></div>
                    <div class="flex">{{doc?.releaseDate | date: 'yyyy-MM-dd'}}</div>
                  </a>
                </ng-template>

                <ng-template #disablePaginationSec>
                    <a [routerLink]="['/bulletin', doc.bulletinDisplayId]" [queryParams]='{type: "sib",page:page}' *ngFor='let doc of serviceBulletins | filterResults : filter |
                    searchFilter: "bulletinDisplayNumber,bulletinDisplayId,releaseDate,description,seriesAsString": search4bulletins | sortBy: {property: column, direction: direction}'
                    class="bmw-lg-sib pointer flex-container row" (click)='addBulletinToHistory(isShowHistory, doc?.id)'>

                    <div class="flex-5" style="text-align:center">
                      <div *ngIf='doc?.savedBulletinGroup; else elseBlock'>
                        <i class="material-icons">star</i>
                      </div>
                      <ng-template #elseBlock>
                        <ng-container *ngIf='doc?.updatedBulletin; else elseBlock2'>
                          <i class="material-icons">new_releases</i>
                        </ng-container>
                      </ng-template>
                      <ng-template #elseBlock2>
                        <ng-container *ngIf='doc?.newBulletin'>
                          <i class="material-icons">fiber_new</i>
                        </ng-container>
                      </ng-template>
                    </div>
                    <div class="flex-8">{{doc?.bulletinDisplayNumber}}</div>
                    <div class="flex-4"></div>
                    <div class="flex-40">{{doc?.description}}</div>
                    <div class="flex-7"></div>
                    <div class="flex-17">
                      <div *ngFor='let series of doc?.series | loadMoreItems : numOfItems' style="float: left; margin-right:18px">
                        {{series?.seriesName}}
                      </div>
                      <div class="pointer" (click)='numOfItems = numOfItems + 6' *ngIf='((doc?.series | loadMoreItems : numOfItems)?.length < doc?.series?.length)'
                        style='float:left' [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>+6</div>
                    </div>
                    <div class="flex-7"></div>
                    <div class="flex">{{doc?.releaseDate | date: 'yyyy-MM-dd'}}</div>
                  </a>
                </ng-template>
              </div>
            </div>
            <pagination-controls (pageChange)="page = $event;pageNumChange( $event)" [hidden]="isPaginateFlag"></pagination-controls>
          </div>
          <div class="flex"></div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Ipad Pro HTML -->
<div *ngIf='screenWidth >= 991 && screenWidth <= 1230'>
  <div (window:orientationchange)="screenRotate($event)">
    <div class="flex-container ">
      <div class="bmw-lg-sib-sidebar flex-15-5">
        <div style="font-weight:bold">Filter by</div>
        <div style="margin-top:15px">Main Group</div>
        <div>
          <select class="form-control" id="group" [(ngModel)]='inputMainGroup'>
            <option [ngValue]="undefined" disabled selected> Select Main Group </option>
            <option *ngFor="let group of mainGroupList" [ngValue]="group">{{group}}</option>
          </select>
        </div>
        <div style="margin-top:25px">Series</div>
        <div>
          <input type="input" (focusout)='updateBodyValues()' placeholder="Enter Series" [(ngModel)]='inputSeries'>
        </div>
        <div style="margin-top:25px">Body</div>
        <div>
          <select class="form-control" id="body" [(ngModel)]='inputBody'>
            <option [ngValue]="undefined" disabled selected> Select Body Type </option>
            <option *ngFor="let type of bodyTypeList" [ngValue]="type.name">{{type.name}}</option>
          </select>
        </div>
        <div style="margin-top:25px">Year Published</div>
        <div class="flex-container row">
          <div class="flex-28" style="padding-top:10px">From</div>
          <div class="flex" style="width:100%">
            <select class="form-control" id="fromYear" [(ngModel)]='inputFromYear'>
              <option *ngFor="let year of fromYears" [ngValue]="year">{{year}}</option>
            </select>
          </div>
        </div>
        <div class="flex-container row">
          <div class="flex-28" style="padding-top:10px">To</div>
          <div class="flex" style="width:100%">
            <select class="form-control" id="toYear" [(ngModel)]='inputToYear'>
              <option *ngFor="let year of toYears" [ngValue]="year">{{year}}</option>
            </select>
          </div>
        </div>
        <div [ngStyle]='{"background-color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}' class="pointer bmw-button-primary lg-primary"
          (click)='applyFilter()'>Apply Filter</div>
        <div class="pointer bmw-button-secondary lg-secondary" (click)='clearFilter()'>Cancel Filter</div>
        <a [routerLink]='["/manage-profile", "bulletin-manager"]'>
          <div class="bmw-lg-sib-bulletin-manager-label" [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>Saved Bulletin Manager</div>
        </a>
      </div>
      <div class="flex">
        <div class="flex-container row">
          <div class="flex-8"></div>
          <div class="flex-81-3">
            <div>
              <div class="flex-30"></div>
              <div class="flex-container row flex-align-center">
                <div [ngClass]='{"bmw-active-link": isShowAll && (APP_SETTINGS.isBMW === "true" || APP_SETTINGS.isMOTORRAD === "true"), 
                "mini-active-link": isShowAll && APP_SETTINGS.isMINI === "true",  "rr-active-link": isShowAll && APP_SETTINGS.isRollsRoyce === "true"}'
                  class="pointer" style="padding-bottom: 20px" (click)='showAll()'>ALL</div>
                <div [ngClass]='{"bmw-active-link": isShowNew && (APP_SETTINGS.isBMW === "true" || APP_SETTINGS.isMOTORRAD === "true"), 
                "mini-active-link": isShowNew && APP_SETTINGS.isMINI === "true",  "rr-active-link": isShowNew && APP_SETTINGS.isRollsRoyce === "true"}'
                  class="pointer" style="padding-bottom: 20px" (click)='showNew()'>
                  NEW
                  <div class="badge" *ngIf="newDocsCount>0" [ngStyle]='{"background-color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>{{newDocsCount}}</div>
                </div>
                <div [ngClass]='{"bmw-active-link": isShowHistory && (APP_SETTINGS.isBMW === "true" || APP_SETTINGS.isMOTORRAD === "true"), 
                "mini-active-link": isShowHistory &&APP_SETTINGS.isMINI === "true",  "rr-active-link": isShowHistory && APP_SETTINGS.isRollsRoyce === "true"}'
                  class="pointer" style="padding-bottom: 20px" (click)='showHistory()'>HISTORY</div>
                <div [ngClass]='{"bmw-active-link": isShowSaved && (APP_SETTINGS.isBMW === "true" || APP_SETTINGS.isMOTORRAD === "true"), 
                "mini-active-link": isShowSaved && APP_SETTINGS.isMINI === "true",  "rr-active-link": isShowSaved && APP_SETTINGS.isRollsRoyce === "true"}'
                  class="pointer" style="padding-bottom: 20px" (click)='showSaved()'>SAVED</div>
              </div>
              <div class="flex-30"></div>
            </div>
            <div class="bmw-lg-sib-content">
              <div class="flex-container row" style="padding:27px 20px 34px 30px">
                <div class="bmw-lg-sib-title flex-50">Service Bulletins</div>
                <div class="flex"></div>
                <div class="flex-32">
                  <form class="input-group" name="findDocs" style="width: 100%">
                    <input type="text" class="form-control" size=15 style="height:34px;font-size:16px;border-radius:0px" placeholder="Find Bulletin"
                      name="techDoc" [(ngModel)]="search4bulletins">
                    <div class="input-group-btn">
                      <button [ngClass]="{'mini-button-style' : APP_SETTINGS.isMINI === 'true', 
                      'rr-button-style' : APP_SETTINGS.isRollsRoyce === 'true', 'bmw-button-style': (APP_SETTINGS.isBMW === 'true'|| APP_SETTINGS.isMOTORRAD === 'true')}" class="btn btn-default"
                        type="submit">
                        <i class="glyphicon glyphicon-search"></i>
                      </button>
                    </div>
                  </form>
                </div>
              </div>
              <div *ngIf='isShowSaved && serviceBulletins?.length > 0'>
                <div *ngFor='let doc of serviceBulletins; let i=index'>
                  <div class="flex-container row" style="margin:0 30px" >
                    <div class="flex-5">
                      <i class="material-icons"> </i>
                    </div>
                    <div class="flex-12" style="font-weight: bold;line-height:1.8">
                      Bulletin number
                    </div>
                    <div class="flex-70" style="font-weight: bold;line-height:1.8">
                      Bulletin Description
                    </div>
                    <div class="flex" style="font-weight: bold;line-height:1.8">
                      Release
                    </div>
                  </div>
                  <div [id]='"pbs" + i' class="bmw-lg-save">
                    <div class="flex-container row" *ngFor='let bulletin of doc?.content' style="margin-left:4%">
                      <div class="flex-5" style="text-align:center">
                        <div *ngIf='bulletin?.savedBulletinGroup; else elseBlock'>
                          <i class="material-icons">star</i>
                        </div>
                        <ng-template #elseBlock>
                          <ng-container *ngIf='bulletin?.updatedBulletin; else elseBlock2'>
                            <i class="material-icons">new_releases</i>
                          </ng-container>
                        </ng-template>
                        <ng-template #elseBlock2>
                          <ng-container *ngIf='bulletin?.newBulletin'>
                            <i class="material-icons">fiber_new</i>
                          </ng-container>
                        </ng-template>
                      </div>
                      <div class="flex-12">{{bulletin?.bulletinDisplayNumber}}</div>
                      <div class="flex-70">{{bulletin.description}}</div>
                      <div class="flex">{{bulletin.releaseDate | date: 'yyyy-MM-dd'}}</div>
                    </div>
                  </div>
                </div>
              </div>
              <div *ngIf='!isShowSaved'>
                <div class="flex-container row" style="border-bottom:2px solid #e9e9e9;">
                  <div class="flex-5"></div>
                  <div style="display:inherit" class="flex-9">
                    <div style="font-weight:bold;font-size:12px;">Bulletin#</div>
                    <i class="fa pointer" (click)="sortByProperty('bulletinIdForSort')" style="margin-left:5px" [ngClass]="{'fa-sort': column != 'bulletinIdForSort', 'fa-sort-asc bmw-sort-control-asc': (column == 'bulletinIdForSort' && isDesc), 'fa-sort-desc': (column == 'bulletinIdForSort' && !isDesc) }"
                      aria-hidden="true"> </i>
                  </div>
                  <div class="flex-4"></div>
                  <div style="display:inherit" class="flex-40">
                    <div style="font-weight:bold;font-size:12px;">Title</div>
                    <i class="fa pointer" (click)="sortByProperty('description')" style="margin-left:5px" [ngClass]="{'fa-sort': column != 'description', 'fa-sort-asc bmw-sort-control-asc': (column == 'description' && isDesc), 'fa-sort-desc': (column == 'description' && !isDesc) }"
                      aria-hidden="true"> </i>
                  </div>
                  <div class="flex-6"></div>
                  <div style="display:inherit" class="flex-17">
                    <div style="font-weight:bold;font-size:12px;">Series</div>
                    <i class="fa pointer" (click)="sortByProperty('seriesName')" style="margin-left:5px" [ngClass]="{'fa-sort': column != 'seriesName', 'fa-sort-asc bmw-sort-control-asc': (column == 'seriesName' && isDesc), 'fa-sort-desc': (column == 'seriesName' && !isDesc) }"
                      aria-hidden="true"> </i>
                  </div>
                  <div class="flex-6"></div>
                  <div style="display:inherit" class="flex">
                    <div style="font-weight:bold;font-size:12px;">Date</div>
                    <i class="fa pointer" (click)="sortByProperty('relseaseDate')" style="margin-left:5px" [ngClass]="{'fa-sort': column != 'releaseDate', 'fa-sort-asc bmw-sort-control-asc': (column == 'releaseDate' && isDesc), 'fa-sort-desc': (column == 'releaseDate' && !isDesc) }"
                      aria-hidden="true"> </i>
                  </div>
                </div>
                <a [routerLink]="['/bulletin', doc.bulletinDisplayId]" [queryParams]='{type: "sib",page:page}' *ngFor='let doc of serviceBulletins | filterResults : filter |
                searchFilter: "bulletinDisplayId,description,releaseDate,description,seriesAsString": search4bulletins | sortBy: {property: column, direction: direction}'
                  class="bmw-lg-sib flex-container row" (click)='addBulletinToHistory(isShowHistory, doc?.id)'>
                  <!-- <div *ngIf='!doc'>Hell</div> -->
                  <div class="flex-5" style="text-align:center">
                    <div *ngIf='doc?.savedBulletinGroup; else elseBlock'>
                      <i class="material-icons">star</i>
                    </div>
                    <ng-template #elseBlock>
                      <ng-container *ngIf='doc?.updatedBulletin; else elseBlock2'>
                        <i class="material-icons">new_releases</i>
                      </ng-container>
                    </ng-template>
                    <ng-template #elseBlock2>
                      <ng-container *ngIf='doc?.newBulletin'>
                        <i class="material-icons">fiber_new</i>
                      </ng-container>
                    </ng-template>
                  </div>
                  <div class="flex-9">{{doc?.bulletinDisplayNumber}}</div>
                  <div class="flex-4"></div>
                  <div class="flex-40">{{doc?.description}}</div>
                  <div class="flex-6"></div>
                  <div class="flex-17">
                    <div *ngFor='let series of doc?.series | loadMoreItems : numOfItems' style="float: left; margin-right:18px">
                      {{series?.seriesName}}
                    </div>
                    <div class="pointer" (click)='numOfItems = numOfItems + 6' *ngIf='((doc?.series | loadMoreItems : numOfItems)?.length < doc?.series?.length)'
                      style='float:left' [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>+6</div>
                  </div>
                  <div class="flex-6"></div>
                  <div class="flex">{{doc?.releaseDate | date: 'yyyy-MM-dd'}}</div>
                </a>
              </div>
            </div>
          </div>
          <div class="flex"></div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Ipad HTML -->
<div *ngIf='screenWidth >= 767 && screenWidth <= 990'>
  <div (window:orientationchange)="screenRotate($event)">
    <div class="flex-container ">
      <div class="flex-25"></div>
      <div class="flex-container row flex-align-center">
        <div [ngClass]='{"bmw-active-link": isShowAll && (APP_SETTINGS.isBMW === "true" || APP_SETTINGS.isMOTORRAD === "true"),
         "mini-active-link": isShowAll && APP_SETTINGS.isMINI === "true",  "rr-active-link": isShowAll && APP_SETTINGS.isRollsRoyce === "true"}'
          class="pointer" style="padding-bottom: 20px" (click)='showAll()'>ALL</div>
        <div [ngClass]='{"bmw-active-link": isShowNew && (APP_SETTINGS.isBMW === "true" || APP_SETTINGS.isMOTORRAD === "true"), 
        "mini-active-link": isShowNew && APP_SETTINGS.isMINI === "true",  "rr-active-link": isShowNew && APP_SETTINGS.isRollsRoyce === "true"}'
          class="pointer" style="padding-bottom: 20px" (click)='showNew()'>
          NEW
          <div class="badge" *ngIf="newDocsCount>0" [ngStyle]='{"background-color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>{{newDocsCount}}</div>
        </div>
        <div [ngClass]='{"bmw-active-link": isShowHistory && (APP_SETTINGS.isBMW === "true" || APP_SETTINGS.isMOTORRAD === "true"),
         "mini-active-link": isShowHistory && APP_SETTINGS.isMINI === "true",  "rr-active-link": isShowHistory && APP_SETTINGS.isRollsRoyce === "true"}'
          class="pointer" style="padding-bottom: 20px" (click)='showHistory()'>HISTORY</div>
        <div [ngClass]='{"bmw-active-link": isShowSaved && (APP_SETTINGS.isBMW === "true" || APP_SETTINGS.isMOTORRAD === "true"),
         "mini-active-link": isShowSaved && APP_SETTINGS.isMINI === "true", "rr-active-link": isShowSaved && APP_SETTINGS.isRollsRoyce === "true"}'
          class="pointer" style="padding-bottom: 20px" (click)='showSaved()'>SAVED</div>
      </div>
      <div class="flex-25"></div>
    </div>
    <div class="bmw-sm-sib">
      <div class="flex-container row" style="padding:17px 15px 0 15px;">
        <div [routerLink]='["/manage-profile", "bulletin-manager"]' class="flex-90" style="font-weight:bold" [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>Saved Bulletin Manager</div>
        <div class="flex">
          <div data-toggle="modal" data-target="#filterModal">
            <i class="material-icons filter-icon" [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>filter_list</i>
            <div class="bmw-sib-filter-label" [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>Filter</div>
          </div>
        </div>
      </div>
      <div class="bmw-sm-sib-title">Service Bulletins</div>
      <div style="margin:0 25% 7% 25%">
        <form class="input-group" name="findDocs" style="width: 100%">
          <input type="text" class="form-control" size=15 style="height:34px;font-size:16px;border-radius:0px" placeholder="Find Bulletin"
            name="techDoc" [(ngModel)]="search4bulletins">
          <div class="input-group-btn">
            <button [ngClass]="{'mini-button-style' : APP_SETTINGS.isMINI === 'true', 'bmw-button-style': (APP_SETTINGS.isBMW === 'true' || APP_SETTINGS.isMOTORRAD === 'true'),
                      'rr-button-style' : APP_SETTINGS.isRollsRoyce=== 'true'}" class="btn btn-default"
              type="submit">
              <i class="glyphicon glyphicon-search"></i>
            </button>
          </div>
        </form>
      </div>
      <div *ngIf='isShowSaved && serviceBulletins?.length > 0'>
        <div *ngFor='let doc of serviceBulletins; let i=index'>
          <div class="flex-container row" style="margin:0 30px" >
            <div class="flex-5">
              <i class="material-icons"> </i>
            </div>
            <div class="flex-12" style="font-weight: bold;line-height:1.8">
              Bulletin number
            </div>
            <div class="flex-65" style="font-weight: bold;line-height:1.8">
              Bulletin Description
            </div>
            <div class="flex" style="font-weight: bold;line-height:1.8">
              Release
            </div>
          </div>
          <div [id]='"pbs" + i' class="bmw-lg-save">
            <div class="flex-container row" *ngFor='let bulletin of doc?.content' style="margin-left:4%">
              {{bulletin?.length}}
              <div class="flex-5" style="text-align:center">
                <div *ngIf='bulletin?.savedBulletinGroup; else elseBlock'>
                  <i class="material-icons">star</i>
                </div>
                <ng-template #elseBlock>
                  <ng-container *ngIf='bulletin?.updatedBulletin; else elseBlock2'>
                    <i class="material-icons">new_releases</i>
                  </ng-container>
                </ng-template>
                <ng-template #elseBlock2>
                  <ng-container *ngIf='bulletin?.newBulletin'>
                    <i class="material-icons">fiber_new</i>
                  </ng-container>
                </ng-template>
              </div>
              <div class="flex-12">{{bulletin?.bulletinDisplayNumber}}</div>
              <div class="flex-65">{{bulletin.description}}</div>
              <div class="flex">{{bulletin.releaseDate | date: 'yyyy-MM-dd'}}</div>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf='!isShowSaved'>
        <div class="flex-container row" style="border-bottom:2px solid #e9e9e9;">
          <div class="flex-5"></div>
          <div style="display:inherit" class="flex-8">
            <div style="font-weight:bold;font-size:12px;">Bulletin#</div>
            <i class="fa pointer" (click)="sortByProperty('bulletinIdForSort')" style="margin-left:5px" [ngClass]="{'fa-sort': column != 'bulletinIdForSort', 'fa-sort-asc bmw-sort-control-asc': (column == 'bulletinIdForSort' && isDesc), 'fa-sort-desc': (column == 'bulletinIdForSort' && !isDesc) }"
              aria-hidden="true"> </i>
          </div>
          <div class="flex-4"></div>
          <div style="display:inherit" class="flex-40">
            <div style="font-weight:bold;font-size:12px;">Title</div>
            <i class="fa pointer" (click)="sortByProperty('description')" style="margin-left:5px" [ngClass]="{'fa-sort': column != 'description', 'fa-sort-asc bmw-sort-control-asc': (column == 'description' && isDesc), 'fa-sort-desc': (column == 'description' && !isDesc) }"
              aria-hidden="true"> </i>
          </div>
          <div class="flex-7"></div>
          <div style="display:inherit" class="flex-17">
            <div style="font-weight:bold;font-size:12px;">Series</div>
            <i class="fa pointer" (click)="sortByProperty('seriesName')" style="margin-left:5px" [ngClass]="{'fa-sort': column != 'seriesName', 'fa-sort-asc bmw-sort-control-asc': (column == 'seriesName' && isDesc), 'fa-sort-desc': (column == 'seriesName' && !isDesc) }"
              aria-hidden="true"> </i>
          </div>
          <div class="flex-7"></div>
          <div style="display:inherit" class="flex">
            <div style="font-weight:bold;font-size:12px;">Date</div>
            <i class="fa pointer" (click)="sortByProperty('releaseDate')" style="margin-left:5px" [ngClass]="{'fa-sort': column != 'releaseDate', 'fa-sort-asc bmw-sort-control-asc': (column == 'releaseDate' && isDesc), 'fa-sort-desc': (column == 'releaseDate' && !isDesc) }"
              aria-hidden="true"> </i>
          </div>
        </div>
        <a [routerLink]="['/bulletin', doc.bulletinDisplayId]" [queryParams]='{type: "sib",page:page}' *ngFor='let doc of serviceBulletins | filterResults : filter |
        searchFilter: "bulletinDisplayId,description,releaseDate,description,seriesAsString": search4bulletins | sortBy: {property: column, direction: direction}'
          class="bmw-lg-sib flex-container row" (click)='addBulletinToHistory(isShowHistory, doc?.id)'>
          <!-- <div *ngIf='!doc'>Hell</div> -->
          <div class="flex-5" style="text-align:center">
            <div *ngIf='doc?.savedBulletinGroup; else elseBlock'>
              <i class="material-icons">star</i>
            </div>
            <ng-template #elseBlock>
              <ng-container *ngIf='doc?.updatedBulletin; else elseBlock2'>
                <i class="material-icons">new_releases</i>
              </ng-container>
            </ng-template>
            <ng-template #elseBlock2>
              <ng-container *ngIf='doc?.newBulletin'>
                <i class="material-icons">fiber_new</i>
              </ng-container>
            </ng-template>
          </div>
          <div class="flex-8">{{doc?.bulletinDisplayNumber}}</div>
          <div class="flex-4"></div>
          <div class="flex-40">{{doc?.description}}</div>
          <div class="flex-7"></div>
          <div class="flex-17">
            <div *ngFor='let series of doc?.series | loadMoreItems : numOfItems' style="float: left; margin-right:18px">
              {{series?.seriesName}}
            </div>
            <div class="pointer" (click)='numOfItems = numOfItems + 6' *ngIf='((doc?.series | loadMoreItems : numOfItems)?.length < doc?.series?.length)'
              style='float:left' [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>+6</div>
          </div>
          <div class="flex-7"></div>
          <div class="flex">{{doc?.releaseDate | date: 'yyyy-MM-dd'}}</div>
        </a>
      </div>
    </div>
    <!-- Modal -->
    <div class="modal fade bmw-sm-modal-dialog" id="filterModal" role="dialog">
      <div class="modal-dialog">

        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" style="color:white">&times;</button>
            <h4 class="modal-title">Filter</h4>
          </div>
          <div class="modal-body">
            <div class="row bmw-no-gutter">
              <div class="row bmw-no-gutter">Sort by</div>
              <div class="row bmw-no-gutter">
                <select [(ngModel)]='inputSortBy' class="bmw-lg-results-select-sortby">
                  <option [ngValue]="undefined" disabled selected> Sort By </option>
                  <option *ngFor='let sort of sortBy' [ngValue]='sort.key'>{{sort.value}}</option>
                </select>
              </div>
            </div>
            <div class="row bmw-no-gutter">
              <div class="row bmw-no-gutter">Main Group</div>
              <div class="row bmw-no-gutter">
                <select [(ngModel)]='inputMainGroup'>
                  <option [ngValue]="undefined" disabled selected> Select Main Group </option>
                  <option *ngFor='let group of mainGroupList' [ngValue]='group'>{{group}}</option>
                </select>
              </div>
            </div>
            <div class="flex-container row">
              <div class="flex-40">Series</div>
              <div class="flex-15"></div>
              <div class="flex">Body</div>
            </div>
            <div class="flex-container row">
              <div class="flex-40">
                <input [(ngModel)]='inputSeries' (focusout)='updateBodyValues()' type="input" placeholder="Enter Series">
              </div>
              <div class="flex-15"></div>
              <div class="flex">
                <select class="form-control" id="body" [(ngModel)]='inputBody'>
                  <option [ngValue]="undefined" disabled selected> Select Body Type </option>
                  <option *ngFor="let type of bodyTypeList" [ngValue]="type.name">{{type.name}}</option>
                </select>
              </div>
            </div>
            <div class="row bmw-no-gutter" style="margin-top:15px">
              <div class="row bmw-no-gutter">Year Published</div>
              <div class="row bmw-no-gutter">
                <div class="row bmw-no-gutter">
                  <div class="col-xs-4 bmw-no-gutter bmw-xs-results-filter-year-label">
                    From
                  </div>
                  <div class="col-xs-7 bmw-no-gutter bmw-width-30-percent bmw-filter-select">
                    <select class="form-control" id="toYear" [(ngModel)]='inputToYear'>
                      <option *ngFor="let year of toYears" [ngValue]="year">{{year}}</option>
                    </select>
                  </div>

                </div>
                <div class="row bmw-no-gutter" style="margin-top:10px">
                  <div class="col-xs-4 bmw-no-gutter bmw-xs-results-filter-year-label">
                    To
                  </div>
                  <div class="col-xs-7 bmw-no-gutter bmw-width-30-percent bmw-filter-select">
                    <select class="form-control" id="toYear" [(ngModel)]='inputToYear'>
                      <option *ngFor="let year of toYears" [ngValue]="year">{{year}}</option>
                    </select>
                  </div>

                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer" style="border: 0px solid white;">
            <div class="row bmw-no-gutter">
              <div class="col-xs-6" style="padding-right:10%">
                <div class="bmw-button-secondary" style="border:2px solid #fff" (click)='clearFilter()'>Clear Filter</div>
              </div>
              <div class="col-xs-6" style="padding-right:10%">
                <div data-dismiss="modal" [ngStyle]='{"background-color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}' class="bmw-button-primary"
                  (click)='applyFilter()'>Apply Filter</div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</div>

<!-- Mobile HTML -->
<div *ngIf='screenWidth >= 319 && screenWidth <= 766'>
  <div (window:orientationchange)="screenRotate($event)">
    <div class="flex-container ">
      <div class="flex-container row flex-align-center">
        <div [ngClass]='{"bmw-active-link": isShowAll && (APP_SETTINGS.isBMW === "true" || APP_SETTINGS.isMOTORRAD === "true"),
         "mini-active-link": isShowAll && APP_SETTINGS.isMINI === "true",
         "rr-active-link": isShowAll && APP_SETTINGS.isRollsRoyce === "true"}'
          class="pointer" style="padding-bottom: 20px" (click)='showAll()'>ALL</div>
        <div [ngClass]='{"bmw-active-link": isShowNew && (APP_SETTINGS.isBMW === "true" || APP_SETTINGS.isMOTORRAD === "true"), 
        "mini-active-link": isShowNew && APP_SETTINGS.isMINI === "true", "rr-active-link": isShowNew && APP_SETTINGS.isRollsRoyce === "true"}'
          class="pointer" style="padding-bottom: 20px" (click)='showNew()'>
          NEW
          <div class="badge" *ngIf="newDocsCount>0" [ngStyle]='{"background-color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>{{newDocsCount}}</div>
        </div>
        <div [ngClass]='{"bmw-active-link": isShowHistory && (APP_SETTINGS.isBMW === "true" || APP_SETTINGS.isMOTORRAD === "true"),
         "mini-active-link": isShowHistory && APP_SETTINGS.isMINI === "true",  "rr-active-link": isShowHistory && APP_SETTINGS.isRollsRoyce === "true"}'
          class="pointer" style="padding-bottom: 20px" (click)='showHistory()'>HISTORY</div>
        <div [ngClass]='{"bmw-active-link": isShowSaved && (APP_SETTINGS.isBMW === "true" || APP_SETTINGS.isMOTORRAD === "true"),
         "mini-active-link": isShowSaved && APP_SETTINGS.isMINI === "true",  "rr-active-link": isShowSaved && APP_SETTINGS.isRollsRoyce === "true"}'
          class="pointer" style="padding-bottom: 20px" (click)='showSaved()'>SAVED</div>
      </div>
    </div>
    <div class="bmw-xs-sib">
      <div class="flex-container row" style="padding:17px 15px 0 15px;">
        <div class="flex" style="font-weight:bold" [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>Saved Bulletin Manager</div>
        <div class="flex-20">
          <div data-toggle="modal" data-target="#filterModal1">
            <i class="material-icons filter-icon" [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>filter_list</i>
            <div class="bmw-sib-filter-label" [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>Filter</div>
          </div>
        </div>
      </div>
      <div class="bmw-xs-sib-title">Service Bulletins</div>
      <div style="width:90%;margin-left:5%;margin-bottom:28px">
        <form class="input-group" name="findDocs" style="width: 100%">
          <input type="text" class="form-control" size=15 style="height:34px;font-size:16px;border-radius:0px" placeholder="Find Bulletin"
            name="techDoc" [(ngModel)]="search4bulletins">
          <div class="input-group-btn">
            <button [ngClass]="{'mini-button-style' : APP_SETTINGS.isMINI === 'true', 
            'rr-button-style' : APP_SETTINGS.isRollsRoyce=== 'true', 'bmw-button-style': (APP_SETTINGS.isBMW === 'true'|| APP_SETTINGS.isMOTORRAD === 'true')}" class="btn btn-default"
              type="submit">
              <i class="glyphicon glyphicon-search"></i>
            </button>
          </div>
        </form>
      </div>
      <div *ngIf='isShowSaved && serviceBulletins?.length > 0'>
        <div *ngFor='let doc of serviceBulletins; let i=index'>
          <div class="flex-container row" style="margin:0 30px" >
            <div class="flex-8">
              <i class="material-icons"> </i>
            </div>
            <div class="flex-58" style="font-weight: bold;line-height:1.8">
              Bulletin number
            </div>
            <div class="flex" style="font-weight: bold;line-height:1.8">
              Release
            </div>
            <div style="font-weight: bold;line-height:1.8">
              Bulletin Description
            </div>
          
          </div>
          <div [id]='"pbs" + i' class="bmw-lg-save">
            <div class="flex-container row" *ngFor='let bulletin of doc?.content'>
              <div class="flex-container row">
                <div class="flex-8" style="text-align:center">
                  <div *ngIf='bulletin?.savedBulletinGroup; else elseBlock'>
                    <i class="material-icons">star</i>
                  </div>
                  <ng-template #elseBlock>
                    <ng-container *ngIf='bulletin?.updatedBulletin; else elseBlock2'>
                      <i class="material-icons">new_releases</i>
                    </ng-container>
                  </ng-template>
                  <ng-template #elseBlock2>
                    <ng-container *ngIf='bulletin?.newBulletin'>
                      <i class="material-icons">fiber_new</i>
                    </ng-container>
                  </ng-template>
                </div>
                <div class="flex-58">{{bulletin?.bulletinDisplayId}}</div>
                <div class="flex">{{bulletin?.releaseDate | date: 'yyyy-MM-dd'}}</div>
              </div>
              <div style="margin-left:8%;padding-bottom: 5px;">
                {{bulletin?.description}}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf='!isShowSaved'>
        <div *ngFor='let doc of serviceBulletins | filterResults : filter |
        searchFilter: "bulletinDisplayId,description,releaseDate,description,seriesAsString": search4bulletins | sortBy: {property: column, direction: direction}; let i=index'
          class="bmw-xs-sib-doc" (click)='addBulletinToHistory(isShowHistory, doc?.id)'>
          <div [routerLink]="['/bulletin', doc.bulletinDisplayId]" [queryParams]='{type: "sib",page:page}'>
            <div class="flex-container row">
              <div class="flex-8">
                <div *ngIf='doc?.savedBulletinGroup; else elseBlock'>
                  <i class="material-icons">star</i>
                </div>
                <ng-template #elseBlock>
                  <ng-container *ngIf='doc?.updatedBulletin; else elseBlock2'>
                    <i class="material-icons">new_releases</i>
                  </ng-container>
                </ng-template>
                <ng-template #elseBlock2>
                  <ng-container *ngIf='doc?.newBulletin'>
                    <i class="material-icons">fiber_new</i>
                  </ng-container>
                </ng-template>
              </div>
              <div class="flex-58">{{doc?.bulletinDisplayNumber}}</div>
              <div class="flex">{{doc?.releaseDate | date: 'yyyy-MM-dd'}}</div>
            </div>
            <div style="margin-left:8%;padding-bottom: 5px;">
              {{doc?.description}}
            </div>
          </div>
          <div class="flex-container row" style="padding-left:8%;min-height:22px;border-top: 1px solid #e6e7e8;">
            <div class="flex-100">
              <div *ngFor="let series of doc?.series | loadMoreItems: numOfItems[i]=seriesToDisplay" style="float:left;margin-left:5px">
                {{series.seriesName}}
              </div>
              <div *ngIf='((doc?.series | loadMoreItems : seriesToDisplay)?.length < doc?.series?.length)' (click)='seriesToDisplay = seriesToDisplay + 6'
                [ngClass]="{'mini-series' : ''|brandTypePipe, 'bmw-series': !(''|brandTypePipe)}">+6</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Modal -->
    <div class="modal fade" id="filterModal1" role="dialog">
      <div class="modal-dialog">

        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" style="color:white">&times;</button>
            <h4 class="modal-title">Filter</h4>
          </div>
          <div class="modal-body">
            <div class="row bmw-no-gutter">
              <div class="row bmw-no-gutter">Sort by</div>
              <div class="row bmw-no-gutter">
                <select [(ngModel)]='inputSortBy' class="bmw-lg-results-select-sortby">
                  <option [ngValue]="undefined" disabled selected> Sort By </option>
                  <option *ngFor='let sort of sortBy' [ngValue]='sort.key'>{{sort.value}}</option>
                </select>
              </div>
            </div>
            <div class="row bmw-no-gutter">
              <div class="row bmw-no-gutter">Main Group</div>
              <div class="row bmw-no-gutter">
                <select [(ngModel)]='inputMainGroup'>
                  <option [ngValue]="undefined" disabled selected> Select Main Group </option>
                  <option *ngFor='let group of mainGroupList' [ngValue]='group'>{{group}}</option>
                </select>
              </div>
            </div>
            <div class="flex-container row">
              <div class="flex-40">Series</div>
              <div class="flex-15"></div>
              <div class="flex">Body</div>
            </div>
            <div class="flex-container row">
              <div class="flex-40">
                <input [(ngModel)]='inputSeries' (focusout)='updateBodyValues()' type="input" placeholder="Enter Series">
              </div>
              <div class="flex-15"></div>
              <div class="flex">
                <select class="form-control" id="body" [(ngModel)]='inputBody'>
                  <option [ngValue]="undefined" disabled selected> Select Body Type </option>
                  <option *ngFor="let type of bodyTypeList" [ngValue]="type.name">{{type.name}}</option>
                </select>
              </div>
            </div>
            <div class="row bmw-no-gutter" style="margin-top:15px">
              <div class="row bmw-no-gutter">Year Published</div>
              <div class="row bmw-no-gutter">
                <div class="row bmw-no-gutter">
                  <div class="col-xs-4 bmw-no-gutter bmw-xs-results-filter-year-label">
                    From
                  </div>
                  <div class="col-xs-7 bmw-no-gutter bmw-width-30-percent bmw-filter-select">
                    <select class="form-control" id="toYear" [(ngModel)]='inputToYear'>
                      <option *ngFor="let year of toYears" [ngValue]="year">{{year}}</option>
                    </select>
                  </div>

                </div>
                <div class="row bmw-no-gutter" style="margin-top:10px">
                  <div class="col-xs-4 bmw-no-gutter bmw-xs-results-filter-year-label">
                    To
                  </div>
                  <div class="col-xs-7 bmw-no-gutter bmw-width-30-percent bmw-filter-select">
                    <select class="form-control" id="toYear" [(ngModel)]='inputToYear'>
                      <option *ngFor="let year of toYears" [ngValue]="year">{{year}}</option>
                    </select>
                  </div>

                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer" style="border: 0px solid white;">
            <div class="row bmw-no-gutter">
              <div class="col-xs-6" style="padding-right:10%">
                <div class="bmw-button-secondary" style="border:2px solid #fff" (click)='clearFilter()'>Clear Filter</div>
              </div>
              <div class="col-xs-6" style="padding-right:10%">
                <div data-dismiss="modal" [ngStyle]='{"background-color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}' class="bmw-button-primary"
                  (click)='applyFilter()'>Apply Filter</div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</div>